import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Modal } from "../../common/Modal/Modal";
import { Button } from "../../common/Button/Button";
import { COLORS } from "../../../assets/constants/styles";

export const CopyModal = ({ isOpen, onClose, onSave }) => {
  const { t } = useTranslation();
  const [copies, setCopies] = useState(1);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(copies);
    setCopies(1);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalTitle>{t("test.copyChatCard")}</ModalTitle>
        <FormContainer>
          <InputGroup>
            <Label htmlFor="copies">{t("test.numberOfCopies")}</Label>
            <Input
              id="copies"
              type="number"
              min="1"
              max="20"
              value={copies}
              onChange={(e) => setCopies(parseInt(e.target.value))}
              required
            />
          </InputGroup>
          <ButtonsContainer>
            <Button
              text={t("common.cancel")}
              onClick={onClose}
              variant="white"
              type="button"
            />
            <Button
              text={t("common.create")}
              variant="violet"
              onClick={handleSubmit}
            />
          </ButtonsContainer>
        </FormContainer>
      </ModalContent>
    </Modal>
  );
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: ${COLORS.black};
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${COLORS.darkGrey};
`;

const Input = styled.input`
  padding: 0.75rem;
  border: 1px solid ${COLORS.lightGrey};
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${COLORS.violet};
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
`;
